import { Alert } from '@elotech/components';

import { textToHtml } from '../../utils';
import { AlertProps } from './types';
import { buildParams, noop } from './utils';

export const alert = ({
  onConfirm = noop,
  onCancel = noop,
  acceptEmptyString = false,
  type,
  ...rest
}: AlertProps) => {
  return Alert[type]?.(buildParams(rest)).then(({ value, dismiss }) => {
    if (value || (acceptEmptyString && value === '')) {
      return onConfirm && onConfirm(value);
    } else {
      return onCancel && onCancel(value, dismiss);
    }
  });
};

export const askForDate = ({
  html = '',
  text = '',
  ...rest
}: Omit<AlertProps, 'acceptEmptyString'>) => {
  const finalHtml = [
    text ? `<div>${textToHtml(text)}</div><br/>` : '',
    html,
    '<input id="elo-swal-date" type="date" class="swal2-input" >'
  ];
  return alert({
    html: finalHtml.join(''),
    preConfirm: () =>
      (document.getElementById('elo-swal-date') as HTMLInputElement)?.value,
    ...rest
  } as any);
};
